<template>
    <nav id="sidebarMenu" class="navigation collapse d-md-block" v-bind:class="{ 'is-narrow': isNarrow }">
        <button class="navigation-expand-btn reset-btn" type="button" @click="isNarrow = true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <span>Свернуть меню</span>
        </button>
        <ul class="navigation-list">
            <template v-for="(category, index) in routes">
                <li class="navigation-item">
                    <h6 class="navigation-heading" :class="['nav-' + index, navClass(index) ? 'is-selected' : '']" @click="hideMenu(index, $event)"
                        title="Переключить меню">
                        <svg>
                            <image :href="category.title.icon_path"/>
                        </svg>
                        <span>{{ category.title.name }}</span>
                        <div class="navigation-heading__btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M5 7.5l5 5 5-5" stroke="#242731" stroke-width="1.667" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                    </h6>
                    <ul :class="['ul-' + index, navClass(index) ? '' : 'hide-menu']">
                        <li v-for="page in category.pages" class="navigation-item">
                            <a class="navigation-link" v-bind:class="{ active: page.active }" aria-current="page"
                                :href="page.path" :title="page.title">
                                <!-- <font-awesome-icon :icon="page.nav_icon" /> -->
                                <svg>
                                    <image :href="page.nav_icon" width="20px"/>
                                </svg>
                                <span>
                                    {{ page.title }}
                                </span>
                            </a>
                        </li>
                    </ul>
                </li>
            </template>
        </ul>
    </nav>
</template>

<script>
export default {
    name: "NavigationComponent",
    props: {
        routes: {
            type: [Array, Object],
            required: true,
        },
    },
    data() {
        return {
            _isNarrow: Boolean(localStorage.getItem('navIsNarrow')),
            _nav_0: this.booleanFromLocalStorage('nav_0'),
            _nav_1: this.booleanFromLocalStorage('nav_1'),
            _nav_2: this.booleanFromLocalStorage('nav_2'),
            _nav_3: this.booleanFromLocalStorage('nav_3'),
            _nav_4: this.booleanFromLocalStorage('nav_4'),
            _nav_5: this.booleanFromLocalStorage('nav_5'),
        }
    },
    methods: {
        hideMenu: function (index, event) {
            event.currentTarget.classList.toggle('is-selected');
            let nav = document.querySelector('.ul-' + index);
            nav.classList.toggle('hide-menu');
            if (nav.classList.value.includes('ul-0')) {
                this._nav_0 = !this._nav_0
                localStorage.setItem('nav_0', this._nav_0)
            }
            else if (nav.classList.value.includes('ul-1')) {
                this._nav_1 = !this._nav_1
                localStorage.setItem('nav_1', this._nav_1)
            }
            else if (nav.classList.value.includes('ul-2')) {
                this._nav_2 = !this._nav_2
                localStorage.setItem('nav_2', this._nav_2)
            }
            else if (nav.classList.value.includes('ul-3')) {
                this._nav_3 = !this._nav_3
                localStorage.setItem('nav_3', this._nav_3)
            }
            else if (nav.classList.value.includes('ul-4')) {
                this._nav_4 = !this._nav_4
                localStorage.setItem('nav_4', this._nav_4)
            }
            else if (nav.classList.value.includes('ul-5')) {
                this._nav_5 = !this._nav_5
                localStorage.setItem('nav_5', this._nav_5)
            }
        },
        navClass: function (index) {
            return this[`_nav_${index}`];
        },
        booleanFromLocalStorage(item) {
            if (localStorage.getItem(item) == 'true') {
                return true
            } else {
                return false
            }
        },
        scrollToSelected(element) {
        if (element.classList.contains('active')) {
            element.scrollIntoView({
                // Если нужен плавный скролл
                // behavior: 'smooth',
                block: 'center',
            });
        }
    },
    },
    computed: {
        isNarrow: {
            get() {
                return this._isNarrow;
            },
            set(val) {
                Boolean(localStorage.getItem('navIsNarrow')) ? localStorage.removeItem('navIsNarrow') : localStorage.setItem('navIsNarrow', 'narrow');
                this._isNarrow = localStorage.getItem('navIsNarrow');
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            let selectedElement = document.querySelector('.active');
            if (selectedElement) {
                this.scrollToSelected(selectedElement);
            }
        });
    }
};
</script>


<style scoped>
    .navigation-heading.is-selected {
        position: relative
    }
    .navigation-heading.is-selected::before {
        position: absolute;
        left: 8px;
        height: 24px;
        content: "|";
        width: 4px;
        background-color: #0678F4;
        color: #0678F4;
        border-radius: 4px;
    }
</style>
